import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {rgba} from "../common/utils.js";
import {Check} from "./icons.js";
import {colors, fontFamily, gap, media} from "./theme.js";
export default function ProcessNavi(props) {
  const {activeStep, steps, onStepClick, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Inner, null, steps.map((s, i) => {
    const {url, text} = s;
    const isDone = i < activeStep;
    const isActive = i === activeStep;
    const clickable = isDone || !!onStepClick;
    return /* @__PURE__ */ React.createElement(StepLink, {
      key: i,
      href: isDone ? url : void 0,
      onClick: () => onStepClick && onStepClick(i),
      clickable
    }, /* @__PURE__ */ React.createElement(StepContainer, {
      active: isActive,
      done: isDone
    }, /* @__PURE__ */ React.createElement(StepNumber, {
      active: isActive,
      done: isDone
    }, isDone ? /* @__PURE__ */ React.createElement(Check, null) : i + 1), /* @__PURE__ */ React.createElement(StepText, {
      active: isActive,
      done: isDone
    }, text)));
  })));
}
const Container = styled.div`
  padding: 0;

  ${media.mobile} {
    padding: 0 8px;
  }
`;
const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${colors.b5};
    z-index: 0;
  }

  ${media.mobile} {
    ${gap("16px")}
    justify-content: normal;
  }
`;
const StepContainer = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  background: ${colors.bg};
  padding: 0 8px;

  ${media.mobile} {
    padding: 0 5px;

    ${({active}) => active && `margin-right: auto;`}
  }
`;
const StepLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  ${({clickable}) => clickable && `cursor: pointer;`}
`;
const StepNumber = styled.div`
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-family: ${fontFamily.secondary};
  font-size: 14px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  color: ${colors.b4};
  background: ${colors.b6};
  margin-right: 16px;

  ${media.mobile} {
    margin-right: 0;
  }

  ${({active}) => active && `
      color: ${colors.c};
      background: ${colors.c4};

      ${media.mobile} {
        margin-right: 16px;
      }
    `}

  ${({done}) => done && `
      color: ${colors.g};
      background: ${rgba(colors.g, 0.3)};
    `}
`;
const StepText = styled.span`
  color: ${colors.b2};
  font-weight: 400;

  ${({active}) => active && `
      color: ${colors.c};

      ${media.mobile} {
        margin-right: 8px;
      }
    `}

  ${({done}) => done && `
      color: ${colors.g};
    `}

  ${media.mobile} {
    ${({active}) => !active && "display: none;"}
  }
`;
